angular.module('dpw.services').factory('dpwBreadCrumbService', ['myAcctAppsLinkStorage', function (myAcctAppsLinkStorage) {

    return {
        buildAppNav: function (appName) {
            var appsLink = getAppsLink();
            return [
                {
                    href: appsLink,
                    text: "Apps"
                },
                {
                    text: appName
                }
            ];

            function getAppsLink() {
                var appsLink = sessionStorage.getItem(myAcctAppsLinkStorage) || '/my-account.html';
                return appsLink;
            }
        },
        buildProfileNav: function () {
            return [
                {
                    href: "/my-account.html",
                    text: "Console"
                },
                {
                    text: "User Profile"
                }
            ];
        }
    };
}]);
